/// <amd-module name="Wit/WorkItemForm/Common/Services/index" />
export * from "./IWorkItemFormCommentService";
export * from "./IWorkItemFormService";
export * from "./WorkItemFormAttachmentsService";
